module.exports = __webpack_public_path__ + "02f0d61f9f7b5f7817049f255dfa9f2e.svg";